/* components/PhotoItem.svelte generated by Svelte v3.21.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	globals,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	null_to_empty,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_store_value,
	space,
	text as text_1,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

const { document: document_1 } = globals;
import { onMount, onDestroy, tick } from "svelte";
import Icon from "../assets/icons.svelte";
import { sharedStates } from "./store.js";

function add_css() {
	var style = element("style");
	style.id = "svelte-1ekjkhv-style";
	style.textContent = ".hidden.svelte-1ekjkhv.svelte-1ekjkhv{display:none !important}.fkhidden.svelte-1ekjkhv.svelte-1ekjkhv{display:none !important}video.svelte-1ekjkhv.svelte-1ekjkhv,canvas.svelte-1ekjkhv.svelte-1ekjkhv{width:100%;user-select:none;object-fit:cover}.photo-item.svelte-1ekjkhv.svelte-1ekjkhv{height:fit-content;position:relative;min-height:var(--minPhotoH);overflow:hidden;flex:1;display:flex;justify-content:center;align-items:center}.title.svelte-1ekjkhv.svelte-1ekjkhv{position:absolute;left:3%;bottom:7%;font-size:1.6rem;color:white;pointer-events:none;padding:0px 6px;border-radius:4px}.ui-container.svelte-1ekjkhv.svelte-1ekjkhv{position:absolute;z-index:101;display:flex;align-items:center;justify-content:space-around;width:90%;height:min(65%, 100px);border-radius:20px;overflow:hidden;background:#0006;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);width:90%}.ui-container.svelte-1ekjkhv>.svelte-1ekjkhv{height:100%}.btn-opt.svelte-1ekjkhv.svelte-1ekjkhv{height:100%;width:15%;transition:250ms ease-in-out width}.btn-opt.opt-on.svelte-1ekjkhv.svelte-1ekjkhv{width:33.34%}input.svelte-1ekjkhv.svelte-1ekjkhv{flex:5;height:60% !important;padding:3px 6px !important;border:solid #ddd 2px;border-radius:10px;width:fit-content;min-width:60px;font-size:1.3rem}.btn-eye.svelte-1ekjkhv.svelte-1ekjkhv{flex:1}.handle.svelte-1ekjkhv.svelte-1ekjkhv{flex:1}.opt-container.svelte-1ekjkhv.svelte-1ekjkhv{z-index:100;transition-delay:150ms;overflow:hidden;opacity:0;position:absolute;margin:0;height:100%;display:flex;justify-content:flex-start;width:100%;pointer-events:none;visibility:hidden;transition:150ms ease-in-out opacity}.opt-container.opt-on.svelte-1ekjkhv.svelte-1ekjkhv{visibility:visible;opacity:1}.opt-container.svelte-1ekjkhv .fake-opt.svelte-1ekjkhv{visibility:hidden;pointer-events:none;width:34%}.opt-container.svelte-1ekjkhv .opt-retake.svelte-1ekjkhv{pointer-events:auto;height:100%;padding:0;background:var(--clrRetake);width:34%;z-index:99}.opt-container.svelte-1ekjkhv .opt-del.svelte-1ekjkhv{z-index:99;pointer-events:auto;padding:0;width:34%;height:100%;background:var(--clrDel)}.opt-container.svelte-1ekjkhv .ios-fix.svelte-1ekjkhv{height:calc(100% + 2px)}.h-flip.svelte-1ekjkhv.svelte-1ekjkhv{transform:scaleX(-1)}button.svelte-1ekjkhv.svelte-1ekjkhv,input.svelte-1ekjkhv.svelte-1ekjkhv{color:white;background:none;padding:0;margin:0}";
	append(document_1.head, style);
}

// (328:2) {#if !selfStates.isUiVisible}
function create_if_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text_1(/*text*/ ctx[2]);
			attr(div, "class", "title svelte-1ekjkhv");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*text*/ 4) set_data(t, /*text*/ ctx[2]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (331:2) {#if !props.cam.isShooting}
function create_if_block(ctx) {
	let div1;
	let button0;
	let button0_class_value;
	let t0;
	let div0;
	let button1;
	let t1;
	let button2;
	let t2;
	let button3;
	let div0_class_value;
	let t3;
	let input;
	let t4;
	let button4;
	let t5;
	let button5;
	let current;
	let dispose;

	const icon0 = new Icon({
			props: {
				name: /*optOn*/ ctx[3] ? "left" : "right",
				stroke: "#ddd"
			}
		});

	const icon1 = new Icon({
			props: { name: "camera", stroke: "#ddd" }
		});

	const icon2 = new Icon({ props: { name: "trash", stroke: "#ddd" } });
	const icon3 = new Icon({ props: { name: "check", stroke: "#ddd" } });

	const icon4 = new Icon({
			props: {
				name: /*selfStates*/ ctx[1].orient === "v"
				? "draglr"
				: "change",
				stroke: "none",
				fill: "#ddd"
			}
		});

	return {
		c() {
			div1 = element("div");
			button0 = element("button");
			create_component(icon0.$$.fragment);
			t0 = space();
			div0 = element("div");
			button1 = element("button");
			t1 = space();
			button2 = element("button");
			create_component(icon1.$$.fragment);
			t2 = space();
			button3 = element("button");
			create_component(icon2.$$.fragment);
			t3 = space();
			input = element("input");
			t4 = space();
			button4 = element("button");
			create_component(icon3.$$.fragment);
			t5 = space();
			button5 = element("button");
			create_component(icon4.$$.fragment);
			attr(button0, "class", button0_class_value = "" + (null_to_empty("btn-opt " + (/*optOn*/ ctx[3] ? "opt-on" : "")) + " svelte-1ekjkhv"));
			attr(button1, "class", "fake-opt svelte-1ekjkhv");
			attr(button2, "class", "opt-retake svelte-1ekjkhv");
			attr(button3, "class", "opt-del svelte-1ekjkhv");
			toggle_class(button3, "ios-fix", /*$sharedStates*/ ctx[6].ifiOS);
			attr(div0, "class", div0_class_value = "" + (null_to_empty("opt-container " + (/*optOn*/ ctx[3] ? "opt-on" : "")) + " svelte-1ekjkhv"));
			attr(input, "type", "text");
			attr(input, "class", "svelte-1ekjkhv");
			attr(button4, "class", "btn-eye svelte-1ekjkhv");
			attr(button5, "class", "handle svelte-1ekjkhv");
			attr(div1, "class", "ui-container svelte-1ekjkhv");
			toggle_class(div1, "fkhidden", !/*selfStates*/ ctx[1].isUiVisible || /*$sharedStates*/ ctx[6].ifHideItemUI);
		},
		m(target, anchor, remount) {
			insert(target, div1, anchor);
			append(div1, button0);
			mount_component(icon0, button0, null);
			append(div1, t0);
			append(div1, div0);
			append(div0, button1);
			append(div0, t1);
			append(div0, button2);
			mount_component(icon1, button2, null);
			append(div0, t2);
			append(div0, button3);
			mount_component(icon2, button3, null);
			append(div1, t3);
			append(div1, input);
			set_input_value(input, /*text*/ ctx[2]);
			append(div1, t4);
			append(div1, button4);
			mount_component(icon3, button4, null);
			append(div1, t5);
			append(div1, button5);
			mount_component(icon4, button5, null);
			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(button0, "click", /*click_handler_2*/ ctx[17]),
				listen(button2, "click", /*handleRetake*/ ctx[8]),
				listen(button3, "click", /*click_handler_3*/ ctx[18]),
				listen(input, "input", /*input_input_handler*/ ctx[19]),
				listen(button4, "click", /*click_handler_4*/ ctx[20])
			];
		},
		p(ctx, dirty) {
			const icon0_changes = {};
			if (dirty & /*optOn*/ 8) icon0_changes.name = /*optOn*/ ctx[3] ? "left" : "right";
			icon0.$set(icon0_changes);

			if (!current || dirty & /*optOn*/ 8 && button0_class_value !== (button0_class_value = "" + (null_to_empty("btn-opt " + (/*optOn*/ ctx[3] ? "opt-on" : "")) + " svelte-1ekjkhv"))) {
				attr(button0, "class", button0_class_value);
			}

			if (dirty & /*$sharedStates*/ 64) {
				toggle_class(button3, "ios-fix", /*$sharedStates*/ ctx[6].ifiOS);
			}

			if (!current || dirty & /*optOn*/ 8 && div0_class_value !== (div0_class_value = "" + (null_to_empty("opt-container " + (/*optOn*/ ctx[3] ? "opt-on" : "")) + " svelte-1ekjkhv"))) {
				attr(div0, "class", div0_class_value);
			}

			if (dirty & /*text*/ 4 && input.value !== /*text*/ ctx[2]) {
				set_input_value(input, /*text*/ ctx[2]);
			}

			const icon4_changes = {};

			if (dirty & /*selfStates*/ 2) icon4_changes.name = /*selfStates*/ ctx[1].orient === "v"
			? "draglr"
			: "change";

			icon4.$set(icon4_changes);

			if (dirty & /*selfStates, $sharedStates*/ 66) {
				toggle_class(div1, "fkhidden", !/*selfStates*/ ctx[1].isUiVisible || /*$sharedStates*/ ctx[6].ifHideItemUI);
			}
		},
		i(local) {
			if (current) return;
			transition_in(icon0.$$.fragment, local);
			transition_in(icon1.$$.fragment, local);
			transition_in(icon2.$$.fragment, local);
			transition_in(icon3.$$.fragment, local);
			transition_in(icon4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon0.$$.fragment, local);
			transition_out(icon1.$$.fragment, local);
			transition_out(icon2.$$.fragment, local);
			transition_out(icon3.$$.fragment, local);
			transition_out(icon4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(icon0);
			destroy_component(icon1);
			destroy_component(icon2);
			destroy_component(icon3);
			destroy_component(icon4);
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let video;
	let t0;
	let canvas;
	let t1;
	let t2;
	let div_id_value;
	let current;
	let dispose;
	let if_block0 = !/*selfStates*/ ctx[1].isUiVisible && create_if_block_1(ctx);
	let if_block1 = !/*props*/ ctx[0].cam.isShooting && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			video = element("video");
			t0 = space();
			canvas = element("canvas");
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			if (if_block1) if_block1.c();
			video.autoplay = true;
			video.muted = true;
			video.playsInline = true;
			attr(video, "class", "svelte-1ekjkhv");
			toggle_class(video, "hidden", !/*selfStates*/ ctx[1].isShooting);
			toggle_class(video, "h-flip", /*selfStates*/ ctx[1].isFrontCam);
			attr(canvas, "class", "svelte-1ekjkhv");
			toggle_class(canvas, "hidden", /*selfStates*/ ctx[1].isShooting);
			toggle_class(canvas, "h-flip", /*selfStates*/ ctx[1].isFrontCam);
			attr(div, "class", "photo-item svelte-1ekjkhv");
			attr(div, "id", div_id_value = "item" + /*props*/ ctx[0].id);
		},
		m(target, anchor, remount) {
			insert(target, div, anchor);
			append(div, video);
			/*video_binding*/ ctx[14](video);
			append(div, t0);
			append(div, canvas);
			/*canvas_binding*/ ctx[15](canvas);
			append(div, t1);
			if (if_block0) if_block0.m(div, null);
			append(div, t2);
			if (if_block1) if_block1.m(div, null);
			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(video, "click", /*click_handler*/ ctx[13]),
				listen(canvas, "click", /*click_handler_1*/ ctx[16]),
				listen(div, "click", click_handler_5)
			];
		},
		p(ctx, [dirty]) {
			if (dirty & /*selfStates*/ 2) {
				toggle_class(video, "hidden", !/*selfStates*/ ctx[1].isShooting);
			}

			if (dirty & /*selfStates*/ 2) {
				toggle_class(video, "h-flip", /*selfStates*/ ctx[1].isFrontCam);
			}

			if (dirty & /*selfStates*/ 2) {
				toggle_class(canvas, "hidden", /*selfStates*/ ctx[1].isShooting);
			}

			if (dirty & /*selfStates*/ 2) {
				toggle_class(canvas, "h-flip", /*selfStates*/ ctx[1].isFrontCam);
			}

			if (!/*selfStates*/ ctx[1].isUiVisible) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div, t2);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!/*props*/ ctx[0].cam.isShooting) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*props*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*props*/ 1 && div_id_value !== (div_id_value = "item" + /*props*/ ctx[0].id)) {
				attr(div, "id", div_id_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			/*video_binding*/ ctx[14](null);
			/*canvas_binding*/ ctx[15](null);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			run_all(dispose);
		}
	};
}

const click_handler_5 = evt => {
	evt.preventDefault();
};

function instance($$self, $$props, $$invalidate) {
	let $sharedStates;
	component_subscribe($$self, sharedStates, $$value => $$invalidate(6, $sharedStates = $$value));
	let { props } = $$props;
	let selfStates = props.itemsMap[props.id];

	// let text = $itemStates[props.id].text;
	let text = selfStates.text;

	// $: {
	//   if (props.itemsMap[props.id]) props.itemsMap[props.id].text = text;
	// }
	console.log(props.id, selfStates, "photoitem");

	const timestamp = new Date();
	let optOn = false;
	let vidElm;
	let canvasElm;
	let bufferElm = document.createElement("canvas");

	function updateAttr(attr, value) {
		if (props.itemsMap[props.id]) {
			$$invalidate(0, props.itemsMap[props.id][attr] = value, props);
		} // props.copyItemsMap();
	}

	function shot() {
		if (!props.cam.gotCamInfo) {
			console.log("set cam info");
			$$invalidate(0, props.cam.gotCamInfo = true, props);

			$$invalidate(
				0,
				props.cam.camInfo = {
					w: vidElm.videoWidth,
					h: vidElm.videoHeight
				},
				props
			);
		}

		// draw to buffer
		const ctx = bufferElm.getContext("2d");

		bufferElm.width = vidElm.videoWidth;
		bufferElm.height = vidElm.videoHeight;
		ctx.drawImage(vidElm, 0, 0);

		// buffer to canvas for display
		const ctx1 = canvasElm.getContext("2d");

		$$invalidate(5, canvasElm.width = vidElm.videoWidth, canvasElm);
		$$invalidate(5, canvasElm.height = vidElm.videoHeight, canvasElm);
		ctx1.drawImage(bufferElm, selfStates.offsetX, selfStates.offsetY);

		// buffer to Base64 image
		////  ////////////
		//////// 这边想清楚是用 img 或 canvas 显示图片后再处理, 暂时注释掉 ////////
		////////////  ////
		// const imgSrc = bufferElm.toDataURL("image/png");
		// // selfStates.isShooting = false;
		// updateAttr("imgSrc", imgSrc);
		////  ////////////
		////////////  ////
		$$invalidate(1, selfStates.isShooting = false, selfStates);

		const now = new Date();
		let hh = now.getHours();
		let mm = now.getMinutes();
		const ampm = hh >= 12 ? "PM" : "AM";
		hh = hh === 12 ? hh : hh % 12;
		hh = hh.toString().length === 1 ? "0" + hh : hh;
		mm = mm.toString().length === 1 ? "0" + mm : mm;
		$$invalidate(2, text = hh + ":" + mm + " " + ampm);
		updateAttr("capTime", now);
		updateAttr("text", text);
		console.log("shot on camera:", props.id);
	}

	function setSelfAsCurrent() {
		$$invalidate(3, optOn = false);

		if (props.currentItemID && props.itemsMap[props.currentItemID] && props.currentItemID !== props.id) {
			$$invalidate(0, props.itemsMap[props.currentItemID].isUiVisible = false, props);
			console.log("-=-=-=-=-=");
		} // props.copyItemsMap();

		props.cam.currentVidElm && $$invalidate(0, props.cam.currentVidElm.srcObject = undefined, props);
		$$invalidate(4, vidElm.srcObject = props.cam.stream, vidElm);
		$$invalidate(0, props.cam.currentVidElm = vidElm, props);
		props.setCurrentItemID(props.id);
	} // props.setCurrentShot(shot);

	function handleRetake() {
		if (props.cam.isShooting) {
			return;
		}

		$$invalidate(1, selfStates.isShooting = true, selfStates);
		set_store_value(sharedStates, $sharedStates.ifHideTab = false, $sharedStates);
		props.setCurrentItemID(props.id);
		props.setCurrentShot(shot);
		$$invalidate(0, props.cam.isShooting = true, props);
		$$invalidate(1, selfStates.isUiVisible = false, selfStates);
		$$invalidate(3, optOn = false);
	}

	onMount(() => {
		// if (ifiOS) {
		//   setTimeout(() => {
		//     // vidElm.srcObject = props.cam.stream;
		//   }, 2000);
		//   console.log("is ios");
		//   // props.cam
		//   //   .reqCam(props.cam.isFrontCam)
		//   //   .then(() => (props.cam.currentVidElm.srcObject = props.cam.stream));
		// } else {
		//   console.log("not ios");
		// }
		console.log(props.cam.stream, "set stream");

		setSelfAsCurrent();

		// props.setCurrentItemID(props.id);
		props.setCurrentShot(shot);

		console.log("mounted", props.id);
	}); // window.scrollBy({
	//   top: document.body.clientHeight,
	//   behavior: "smooth"
	// });

	onDestroy(() => {
		//// TODO ////////////
		//////// delete stored images  ////////
		bufferElm.remove();

		// vidElm.srcObject.getTracks().forEach(t => t.stop());
		// selfStates = props.itemsMap[props.id];
		// isShooting=props.itemsMap[props.id].isShooting
		//manually update dom
		console.log("ondestroy", props.id);
	});

	const click_handler = evt => {
		if (!props.cam.isShooting) {
			$$invalidate(1, selfStates.isUiVisible = true, selfStates);
			set_store_value(sharedStates, $sharedStates.ifHideItemUI = false, $sharedStates);
			set_store_value(sharedStates, $sharedStates.ifHideTab = true, $sharedStates);
			setSelfAsCurrent();
		}
	};

	function video_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(4, vidElm = $$value);
		});
	}

	function canvas_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(5, canvasElm = $$value);
		});
	}

	const click_handler_1 = evt => {
		if (!props.cam.isShooting) {
			$$invalidate(1, selfStates.isUiVisible = true, selfStates);
			set_store_value(sharedStates, $sharedStates.ifHideItemUI = false, $sharedStates);
			set_store_value(sharedStates, $sharedStates.ifHideTab = true, $sharedStates);
			setSelfAsCurrent();
		}
	};

	const click_handler_2 = e => {
		$$invalidate(3, optOn = !optOn);
		console.log(optOn, selfStates.isUiVisible);
	};

	const click_handler_3 = () => {
		$$invalidate(3, optOn = false);
		$$invalidate(1, selfStates.isUiVisible = false, selfStates);
		set_store_value(sharedStates, $sharedStates.ifHideTab = false, $sharedStates);

		if (selfStates.isShooting) {
			$$invalidate(0, props.cam.isShooting = false, props);
		}

		props.delItem(props.id);
	};

	function input_input_handler() {
		text = this.value;
		$$invalidate(2, text);
	}

	const click_handler_4 = e => {
		$$invalidate(1, selfStates.isUiVisible = false, selfStates);
		set_store_value(sharedStates, $sharedStates.ifHideTab = false, $sharedStates);
	};

	$$self.$set = $$props => {
		if ("props" in $$props) $$invalidate(0, props = $$props.props);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*props*/ 1) {
			$: {
				$$invalidate(1, selfStates = props.itemsMap[props.id]);
			}
		}
	};

	return [
		props,
		selfStates,
		text,
		optOn,
		vidElm,
		canvasElm,
		$sharedStates,
		setSelfAsCurrent,
		handleRetake,
		bufferElm,
		timestamp,
		updateAttr,
		shot,
		click_handler,
		video_binding,
		canvas_binding,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		input_input_handler,
		click_handler_4
	];
}

class PhotoItem extends SvelteComponent {
	constructor(options) {
		super();
		if (!document_1.getElementById("svelte-1ekjkhv-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { props: 0 });
	}
}

export default PhotoItem;